import React from "react";
import { dispatch } from '@rematch/core';
import { withRouter } from 'react-router-dom';
import { Input, Grid, Card, Message, Icon, Accordion, Button, Image, Popup} from "semantic-ui-react";
import { Form } from 'formsy-semantic-ui-react';
import nowWorkspaceImage from '../../../../../images/grafix-banner/noWorkspace.svg';
import LoadingComponent from '../../../../common/LoadingComponent';
import EllipsisTooltip from "../../../../common/EllipsisTooltip";
import noImage from '../../../../../images/common/broken-image.png'
import { Dimmer, Loader } from 'semantic-ui-react';

const NoPublishedPlaybookComponent = function (props) {
    return (
        <Grid.Column style={{ paddingTop: '2em', textAlign: "center" }}>
            <Image src={nowWorkspaceImage} size='large' centered={true} />
            <p >Sorry, there are no published playbooks available. Do you want to create new playbook?</p>
            <div>
                <Button id='createPlaybook' className="button-submit" onClick={props.redirectToPlaybook} >CREATE NEW PLAYBOOK</Button>
            </div>
        </Grid.Column>);
}

class SelectPlaybook extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchValue: "",
            playbookType: "",
            category: "",
            scope: "",
            categories: [],
            activeIndex: 1,
            popup:false
        }
        this.parentRef = React.createRef();
        this.SearchByName = this.SearchByName.bind(this);
        this.redirectToPlaybook = this.redirectToPlaybook.bind(this);
    }

    componentWillMount() {
        let payload = {};
        payload.organizationId = this.props.match.params.workspaceId;
        dispatch.initiatives.getPublishedPractices(payload);
        dispatch.app.setRouteParams(this.props.match.params)
        // dispatch.app.setCollapsedResourcePaneIndexTemp(null)
    }

    async onClickCard(data) {
        await dispatch.initiatives.setSelectedPlaybookData(data)
        await dispatch.initiatives.showResourecePane("PublishPlaybook")
        await dispatch.initiatives.splitAt("60%");
        await dispatch.app.setCollapsedResourcePaneIndexTemp(null)
        await dispatch.initiatives.getPracticeById(data._id)
        this.setState({ practiceId: data._id })
        if(this.props.selectedPlaybookData.createInitiative==false){
            this.popup=true
        }else{
            this.popup=false
        }
    }

    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index

        this.setState({ activeIndex: newIndex })
    }

    closePopUp(){
        this.popup=false 
        this.redirectToInitative();
    }

    SearchByName(data) {
        this.setState({ searchValue: data.target.value });
        let practiceName = data.target.value;
        let payload = {};
        payload.name = practiceName;
        payload.organizationId = this.props.selectedOrganisation.id;
        payload.baseCategory = this.state.playbookType;
        payload.category = this.state.category;
        payload.scope = this.state.scope;
        dispatch.initiatives.searchPractices(payload);
    }

    getFilteredPractices = () => {
        // dispatch.initiatives.showResourecePane(null);
        let payload = {};
        payload.name = this.state.searchValue;
        payload.organizationId = this.props.selectedOrganisation.id;
        payload.baseCategory = this.state.playbookType;
        payload.category = this.state.category;
        payload.scope = this.state.scope;
        dispatch.initiatives.searchPractices(payload);
    }

    resetAdvancedSearch = () => {
        document.getElementById("advancedSearchForm").reset();
        this.setState({
            playbookType: "",
            category: "",
            scope: "",
            categories: []
        })
        let payload = {};
        payload.name = this.state.searchValue;
        payload.organizationId = this.props.selectedOrganisation.id;
        payload.baseCategory = "";
        payload.category = "";
        payload.scope = "";
        dispatch.initiatives.searchPractices(payload);
    }

    clearFilter() {
        this.setState({ searchValue: "" })
        let payload = {};
        payload.name = "";
        payload.organizationId = this.props.selectedOrganisation.id;
        dispatch.initiatives.searchPractices(payload)
    }

    onFocus() {
        //dispatch.initiatives.showResourecePane(null)
    }

    handleChangePlaybookType = (data) => {

        if (data.target.value !== 'Select Knowledge Bank') {
            this.setState({ playbookType: data.target.value })
            this.props.baseCategoriesArr.forEach(baseCategory => {
                if (baseCategory._id === data.target.value) {
                    this.setState({
                        categories: baseCategory.nodes
                    })
                }
            })
        }
        else {
            this.setState({
                categories: [],
                playbookType: "",
                category: ""
            })
        }
        return;
    }

    handleChangeCategory = (data) => {
        if (data.target.value !== 'Select Category') {
            this.setState({ category: data.target.value });
        } else {
            this.setState({ category: "" });
        }
    }

    handleChangeScope = (data) => {
        if (data.target.value !== 'Access Control') {
            this.setState({ scope: data.target.value });
        } else {
            this.setState({ scope: "" });
        }
    }

    redirectToPlaybook() {
        dispatch.lifeCycle.setCreatePracticeCard(true);
        dispatch.lifeCycle.showLangingPage(false);
        const history = this.props.history;
        history.push({
            pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_pb`
        });
    }

    redirectToInitative() { 
        const history = this.props.history;
        history.push({
            pathname: `/app/${this.props.match.params.accountId}/_ws/${this.props.match.params.workspaceId}/_in/indesign`
        });
    }

    addDefaultSrc = (ev) => {
        ev.target.src = noImage
    }


    render() {
        const { activeIndex } = this.state
        let windowDimension = this.props.componentDesignerDimension;
        let designerHeight = (windowDimension.windowHeight - windowDimension.height) - 50;
        return (
            <div>
                {!this.popup?
                 <div ref={this.parentRef} style={{ width: "100%", maxHeight: designerHeight ? designerHeight : 200, overflowY: "scroll" }}>
                {this.props.intitiativeCountData.publishedPlaybookCount === 0 ? <NoPublishedPlaybookComponent redirectToPlaybook={this.redirectToPlaybook} /> :
                    <Grid className="searchPlaybook containerBox" >
                        <LoadingComponent active={this.props.loadingPracticeDataById} message="Fetching Playbook details..." />
                        <Grid.Row style={{ margin: "0 0 20px 0" }}>
                            <p>Please Select a playbook Create Initiative</p>
                        </Grid.Row>
                        <Grid.Row style={{ margin: "0 0 20px 0" }}>

                            <Input id='search'
                                icon={<Icon name={this.state.searchValue ? 'close' : 'search'}
                                    link={this.state.searchValue ? true : false} onClick={() => this.clearFilter()} />}
                                placeholder='Search by Playbook name and Tags'
                                onChange={this.SearchByName}
                                value={this.state.searchValue}
                                onFocus={() => this.onFocus()}
                                onBlur={() => { }}
                                autoFocus={this.props.resourcePaneFlag === null ? true : false}
                            />
                        </Grid.Row>
                        <Grid.Row >
                            <Accordion style={{ margin: "0 0 20px 0", background: "#F3F7FB" }} className='w_100' styled>
                                <Accordion.Title active={activeIndex === 0} index={0} onClick={this.handleClick}>
                                    <Icon name='dropdown' />
                                    Advanced Search Options
                        </Accordion.Title>
                                <Accordion.Content active={activeIndex === 0}>
                                    <Form noValidate
                                        ref={ref => this.form = ref}
                                        id='advancedSearchForm'
                                        className="w_100 "
                                        onValidSubmit={this.getFilteredPractices}
                                    >
                                        <Grid columns={3} >
                                            <Grid.Row>
                                                <Grid.Column width={6}>
                                                    <Form.Field
                                                        label='Knowledge Bank'
                                                        id='playbookType'
                                                        control='select'
                                                        onChange={this.handleChangePlaybookType}
                                                        value={this.state.playbookType ? this.state.playbookType : 'Select Knowledge Bank'}
                                                    >
                                                        <option>Select Knowledge Bank</option>
                                                        {this.props.baseCategoriesArr && this.props.baseCategoriesArr && this.props.baseCategoriesArr.length > 0 &&
                                                            this.props.baseCategoriesArr.map(function (baseCategory, index) {
                                                                return (
                                                                    <option key={index} value={baseCategory._id} >{baseCategory.name}</option>
                                                                );
                                                            }, this)
                                                        }
                                                    </Form.Field>
                                                </Grid.Column>
                                                <Grid.Column width={5}>
                                                    <Form.Field label='Category'
                                                        id='category' control='select'
                                                        onChange={this.handleChangeCategory}>
                                                        <option>Select Category</option>
                                                        {this.state.categories && this.state.categories.length > 0 &&
                                                            this.state.categories.map(function (category, index) {
                                                                return (
                                                                    <option key={index} value={category._id}>{category.name}</option>
                                                                );
                                                            }, this)}
                                                    </Form.Field>
                                                </Grid.Column>
                                                <Grid.Column width={5}>
                                                    <Form.Field label='Public / Private'
                                                        id='scope' control='select'

                                                        onChange={this.handleChangeScope}
                                                        value={this.state.scope ? this.state.scope : 'Publishing Level'}
                                                    >
                                                        <option value='Access Control'>Publishing Level</option>
                                                        <option value='Private'>Workspace Library</option>
                                                        <option value='Public'>Public Library</option>
                                                    </Form.Field>
                                                </Grid.Column>
                                            </Grid.Row>
                                            <Grid.Column width={16} >
                                                <Button className='pull-right button-submit' onClick={this.getFilteredPractices} >
                                                    Search
                                        </Button>
                                                <Button className='pull-right button-cancel' onClick={this.resetAdvancedSearch}>
                                                    Reset
                                        </Button>
                                            </Grid.Column>
                                            <Grid.Row>

                                            </Grid.Row>
                                        </Grid>
                                    </Form>
                                </Accordion.Content>
                            </Accordion>
                        </Grid.Row>
                        <Grid.Row>
                            {this.props.searchedPracticeData && this.props.searchedPracticeData.length > 0 ?
                                <Card.Group>
                                    {this.props.searchedPracticeData && this.props.searchedPracticeData.map((item, i) => {
                                        if(item.createInitiative !== false){
                                            return <Card key={item._id} className={(this.props.selectedPlaybookData._id === item._id) ? "packCard selectedPlaybook" : "packCard "} id={i} onClick={() => this.onClickCard(item)}>
                                            <Card.Header>
                                                <EllipsisTooltip name={item.name} />
                                            </Card.Header>
                                            <Card.Content >
                                                <Image onError={this.addDefaultSrc} className="fitImage" src={item.picture} alt='' />
                                                <div className="badge2">
                                                    <span className={`badgeblock ${item.scope === 'Public' ? 'badge2Public' : ''} ${item.scope === 'Private' ? 'badge2Private' : ''}`}>{item.scope === "Private" ? "Workspace" : item.scope}</span>
                                                </div>
                                            </Card.Content>
                                        </Card>
                                        }    
                                    })}
                                </Card.Group> :
                                <div className="w_100">
                                    <Message warning icon>
                                        <Message.Content>
                                            Not found?&nbsp;<span onClick={() => this.redirectToPlaybook()} style={{ color: "#007dcf", cursor: "pointer" }}>Click here</span>&nbsp;to create new playbook.
                                </Message.Content>
                                    </Message>
                                </div>
                            }
                        </Grid.Row>
                    </Grid >
                }
            </div>:""} 
            {this.popup?
            <div className="rrt-confirm-holder"> 
             <Dimmer active style={{ zIndex: 120, backgroundColor: 'rgba(0, 0, 0, 0.25)',width:"100%" }} page={true}></Dimmer>         
              <div className="rrt-confirm animated fadeIn">
                {this.props.user._id==this.props.selectedPlaybookData.createdBy?
                 <div className="rrt-message" style={{textAlign:"left"}}>
                    <div className="confirmMessage">
                      <label>{this.props.selectedPlaybookData.name}</label>
                      <p>The "Create Initiative" option is currently disabled</p>
                    </div>   
                 </div>:
                 <div className="rrt-message">
                    <div className="confirmMessage">
                    <label>{this.props.selectedPlaybookData.name}</label>
                     <p>Permissions to create initiatives for this playbook are turn off please contact the playbook designer</p>
                    </div>
                    
                 </div>
                }
                <div className="rrt-buttons-holder">
                     <button className="rrt-button rrt-ok-btn toastr-control" onClick={() => this.closePopUp()} >OK</button>          
                </div>
              </div> 
              </div>
              :""
            }
            </div>
        );
          
    }
}

export default withRouter(SelectPlaybook);

